<template lang="pug">
  v-container(fluid grid-list-lg)
    v-layout(row wrap) 
      v-flex(md4 xs12)
        v-layout(row wrap)
          v-flex
            DueDate(:service="service.reconcile" minDay="2")
          v-flex(xs12)
            Status(serviceID="193" service="Reconcile")
          v-flex(xs12)
            v-card
              v-toolbar.elevation-0(height="45" color="gray")
                v-toolbar-title
                  h1.subheading {{ $t('labels.note') }}
                v-spacer
                v-btn(small v-if="checkRightStatus(35)" color='info' dark @click="updateNote()" icon)
                  v-icon(small) save
              v-card-text
                v-textarea(rows="8" v-model="service.reconcile.note")  
          v-flex(xs12)
            ReconcileStatus
            
        
      v-flex(md8 xs12)
        CommentList(:refID="location.storeID" :typeId="5")
            
          
          

</template>

<script>
import ReconcileStatus from '../../Reconcile/Setting/components/Status'
import ReconcileService from '../../Reconcile/Setting/service.js'
import DueDate from './components/DueDate'
import CommentList from '../../Comment/components/List'
import AppealList from '../../Reconcile/Appeal/components/StoreAppealList'
import Status from './Status'
import { mapGetters } from "vuex";
// import ListByStore from "../../Tasks/components/ListByStore"
// const ListByStore = () => import("../../Tasks/components/ListByStore")
export default {
  data() {
    return {
      active: null
    }
  },
  components: {
    ReconcileStatus,
    // ListByStore,
    Status,
    AppealList,
    DueDate,
    CommentList
  },
  computed: {
    ...mapGetters("location", ["location", 'service']),
    ...mapGetters('global', ['currentUser', 'checkRightStatus']),
    dueDateCount() {
      return this.$moment(this.service.reconcile.dueDate).diff(
        this.$moment().format("MM/DD/YYYY"),
        "day"
      );
    },
  },
  methods: {
    updateNote() {
      ReconcileService.update(this.service.reconcile.storeID, 193, this.service.reconcile)
        .then(result => {
          this.$swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).fire({
            type: 'success',
            title: 'Reconcile Service is started'
          })
          this.$emit('updated')
        }).catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style scoped>
</style>